
const HelpServer = () => import('@/../../coreui/components/helpServer')
const HelpTutorials = () => import('../../components/help/Tutorials')
const HelpVideos = () => import('../../components/help/Videos')
const HelpProducts = () => import('../../components/help/Products')
const HelpSensors = () => import('../../components/help/Sensors')

export default function buildMenu (allowed) {
  var routes =  [
      {
        path: '/HelpVideos',
        name: 'HelpVideos',
        component: HelpVideos
      },
      {
        path: '/HelpTutorials',
        name: 'HelpTutorials',
        component: HelpTutorials
      },
      {
        path: '/HelpExternal',
        name: 'HelpExternal',
        component: HelpServer
      },
      {
        path: '/HelpProducts',
        name: 'HelpProducts',
        component: HelpProducts
      },
      {
        path: '/HelpSensors',
        name: 'HelpSensors',
        component: HelpSensors
      },
    ] 
  return routes
}
